// services/VehicleService.js

const backend = process.env.REACT_APP_BACKEND

let dataCache = null;
let fetchPromise = null;

const VehicleService = {
  getAxaVehicules: async () => {
    // 1. If we have the data, return it immediately
    if (dataCache) {
      return dataCache;
    }

    // 2. If a request is already running, return that existing promise
    // (This fixes the race condition)
    if (fetchPromise) {
      return fetchPromise;
    }

    // 3. Otherwise, start the request
    fetchPromise = fetch(`${backend}/service.php`,{
            method:'post',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({action:'axa_vehicules'})
        }).then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then((data) => {
            // Cache the result
            dataCache = data;
            // Clear the promise so it can be garbage collected (optional)
            fetchPromise = null; 
            return data;
        })
        .catch((err) => {
            // Reset promise on error so we can try again later
            fetchPromise = null;
            throw err;
        });

    return fetchPromise;
  }
};

export default VehicleService;